import { Injectable } from '@nestjs/common';
import { EmployeeDetails } from '../employee-details.entity';
import { EmployeeEducationDetails } from '../employee-education-details.entity';
import { EmployeeExperienceDetails } from '../employee-experience-details.entity';
import { EmployeeFamilyDetails } from '../employee-family-details.entity';
import { EmployeeIdProofDetails } from '../employee-id-proof-details.entity';
import { EmployeeDetailsDTO } from './employee-details.dto';
import { EmployeeFamilyDetailsDTO } from './employee-family-details.dto';

@Injectable()
export class EmployeeDetailsAdapter {
  /**
   * 
   * @param EmployeeDetailsDTO 
   * @param isUpdate 
   * @returns 
   */
  public convertDtoToEntity(employeesDto: EmployeeDetailsDTO, isUpdate: boolean = false): EmployeeDetails {

    const employees = new EmployeeDetails();
    if (isUpdate) {
      employees.employeeId = employeesDto.employeeId;
    }
    employees.employeeName = employeesDto.employeeName;
    employees.employeeLastName = employeesDto.employeeLastName
    employees.employeeCode = employeesDto.employeeCode;
    employees.mobileNumber = employeesDto.mobileNumber;
    employees.teamCode = employeesDto.teamCode;
    employees.employeeRole = employeesDto.employeeRole;
    employees.unitId = employeesDto.unitId;
    employees.prefix = employeesDto.prefix;
    employees.dateOfBirth = employeesDto.dateOfBirth;
    employees.gender = employeesDto.gender;
    employees.maritualStatus = employeesDto.maritualStatus;
    employees.altMobileNumber = employeesDto.altMobileNumber;
    employees.emailID = employeesDto.emailID;
    employees.bloodGroup = employeesDto.bloodGroup;
    employees.nationality = employeesDto.nationality;
    employees.departmentId = employeesDto.departmentId;
    employees.priorityOne = employeesDto.priorityOne;
    employees.priorityType = employeesDto.priorityType;
    employees.currentAddress = employeesDto.currentAddress;
    employees.permanentAddress = employeesDto.permanentAddress;
    employees.qualification = employeesDto.qualification;
    employees.yearsOfExperience = employeesDto.yearsOfExperience;
    employees.companyEmail = employeesDto.companyEmail;
    employees.employeeMode = employeesDto.employeeMode;
    employees.employeeStatus = employeesDto.employeeStatus;
    employees.contractorName = employeesDto.contractorName;
    employees.shiftGroup = employeesDto.shiftGroup;
    employees.dateOfJoin = employeesDto.dateOfJoin;
    employees.dateOfleave = employeesDto.dateOfleave;
    employees.workstationNumber = employeesDto.workstationNumber;
    employees.healthCardNumber = employeesDto.healthCardNumber;
    employees.uanNumber = employeesDto.uanNumber;
    employees.esiNumber = employeesDto.esiNumber;
    employees.panNumber = employeesDto.panNumber;
    employees.salary = employeesDto.salary;
    employees.bankAccountNumber = employeesDto.bankAccountNumber;
    employees.bankName = employeesDto.bankName;
    employees.ifscCode = employeesDto.ifscCode;
    employees.designation = employeesDto.designation;
    employees.dateOfEntry = employeesDto.dateOfEntry;
    employees.emergencyContactNo = employeesDto.emergencyContactNo;
    employees.emergencyContactName = employeesDto.emergencyContactName;
    employees.isProbPeriodCompleted = employeesDto.isProbPeriodCompleted;
    employees.transportation = employeesDto.transportation;
    employees.accommodation = employeesDto.accommodation;
    employees.isAuditCompleted = employeesDto.isAuditCompleted;
    employees.skillSet = employeesDto.skillSet;
    employees.pickUpPoint = employeesDto.pickUpPoint;
    employees.routeNumber = employeesDto.routeNumber;
    employees.employeeCategory = employeesDto.employeeCategory;
    employees.wageType = employeesDto.wageType;
    employees.image = employeesDto.image;
    employees.createdUser = employeesDto.createdUser;
    employees.updatedUser = employeesDto.updatedUser;
    employees.employeeType = employeesDto.employeeType;
    employees.aadhaarNumber = employeesDto.aadhaarNumber;
    employees.reportingManager = employeesDto.reportingManager
    employees.state = employeesDto.state;
    employees.pinCode = employeesDto.pinCode;
    employees.permanentState = employeesDto.permanentState;
    employees.permanentPinCode = employeesDto.permanentPinCode;
    employees.ghiNo = employeesDto.ghiNo;
    employees.gpaNo = employeesDto.gpaNo;

    employees.isActive = employeesDto.isActive == undefined ? true : employeesDto.isActive;
    if (employeesDto.familyDetails) {
      const familyDetails: EmployeeFamilyDetails[] = [];
      for (const sampleDtoFam of employeesDto.familyDetails) {
        const familyDetailsObj = new EmployeeFamilyDetails();
        if (isUpdate) {
          familyDetailsObj.employeeFamilyId = sampleDtoFam.employeeFamilyId;
        }
        familyDetailsObj.relation = sampleDtoFam.relation;
        familyDetailsObj.famAadhaarNo = sampleDtoFam.famAadhaarNo;
        familyDetailsObj.contactNo = sampleDtoFam.contactNo;
        familyDetailsObj.famDateOfBirth = sampleDtoFam.famDateOfBirth;
        familyDetailsObj.familyMemName = sampleDtoFam.familyMemName;
        familyDetailsObj.contactNo = sampleDtoFam.contactNo;
        familyDetailsObj.isActive = sampleDtoFam.isActive;
        familyDetails.push(familyDetailsObj)
      }
      employees.familyDetails = familyDetails
      if (isUpdate) {
        employees.updatedUser = employeesDto.updatedUser;
      } else {
        employees.isActive = true;
        // employees.isTerminated = No;
      }
    }
    if (employeesDto.educationDetails) {
      const educationDetails: EmployeeEducationDetails[] = [];
      for (const sampleDtoEdu of employeesDto.educationDetails) {
        const educationDetailsObj = new EmployeeEducationDetails();
        if (isUpdate) {
          educationDetailsObj.employeeEducationId = sampleDtoEdu.employeeEducationId;
        }
        educationDetailsObj.empQualification = sampleDtoEdu.empQualification;
        educationDetailsObj.specialization = sampleDtoEdu.specialization;
        educationDetailsObj.dateOfPassOut = sampleDtoEdu.dateOfPassOut;
        educationDetailsObj.percentage = sampleDtoEdu.percentage;
        educationDetailsObj.isActive = sampleDtoEdu.isActive;
        educationDetails.push(educationDetailsObj)
      }
      employees.educationDetails = educationDetails
      if (isUpdate) {
        employees.updatedUser = employeesDto.updatedUser;
      } else {
        employees.isActive = true;
      }
    }
    if (employeesDto.experienceDetails) {
      const experienceDetails: EmployeeExperienceDetails[] = [];
      for (const sampleDtoExp of employeesDto.experienceDetails) {
        const educationDetailsObj = new EmployeeExperienceDetails();
        if (isUpdate) {
          educationDetailsObj.employeeExperienceId = sampleDtoExp.employeeExperienceId;
        }
        educationDetailsObj.organisation = sampleDtoExp.organisation;
        educationDetailsObj.designation = sampleDtoExp.designation;
        educationDetailsObj.fromDate = sampleDtoExp.fromDate;
        educationDetailsObj.toDate = sampleDtoExp.toDate;
        educationDetailsObj.experience = sampleDtoExp.experience;
        educationDetailsObj.isActive = sampleDtoExp.isActive;
        experienceDetails.push(educationDetailsObj)
      }
      employees.experienceDetails = experienceDetails
      if (isUpdate) {
        employees.updatedUser = employeesDto.updatedUser;
      } else {
        employees.isActive = true;
        // employees.isTerminated = No;
      }
    }

    if (employeesDto.idProofDetails) {
      const idProofDetails: EmployeeIdProofDetails[] = [];
      for (const sampleDtoIdProof of employeesDto.idProofDetails) {
        const idProofdetailsObj = new EmployeeIdProofDetails();
        if (isUpdate) {
          idProofdetailsObj.employeeIdProofId = sampleDtoIdProof.employeeIdProofId;
        }
        idProofdetailsObj.idNumber = sampleDtoIdProof.idNumber;
        idProofdetailsObj.idType = sampleDtoIdProof.idType;
        idProofdetailsObj.isActive = sampleDtoIdProof.isActive;
        idProofDetails.push(idProofdetailsObj)
      }
      employees.idProofDetails = idProofDetails
      if (isUpdate) {
        employees.updatedUser = employeesDto.updatedUser;
      } else {
        employees.isActive = true;
      }
    }
    console.log('employees', employees)
    return employees;

  }


  public convertEntityToDto(employeeObject: EmployeeDetails, isUpdate: boolean = false): EmployeeDetailsDTO {
    const employeeDetailsDTO = new EmployeeDetailsDTO;
    if (isUpdate) {
      employeeDetailsDTO.employeeId = employeeObject.employeeId;
    }
    employeeDetailsDTO.employeeId = employeeObject.employeeId;
    employeeDetailsDTO.employeeName = employeeObject.employeeName;
    employeeDetailsDTO.employeeLastName = employeeObject.employeeLastName;
    employeeDetailsDTO.employeeCode = employeeObject.employeeCode;
    employeeDetailsDTO.mobileNumber = employeeObject.mobileNumber;
    employeeDetailsDTO.teamCode = employeeObject.teamCode;
    employeeDetailsDTO.unitId = employeeObject.unitId;
    employeeDetailsDTO.designation = employeeObject.designation;
    employeeDetailsDTO.employeeRole = employeeObject.employeeRole;
    employeeDetailsDTO.dateOfBirth = employeeObject.dateOfBirth;
    employeeDetailsDTO.isActive = employeeObject.isActive;
    employeeDetailsDTO.createdAt = employeeObject.createdAt;
    employeeDetailsDTO.updatedAt = employeeObject.updatedAt;
    employeeDetailsDTO.createdUser = employeeObject.createdUser;
    employeeDetailsDTO.updatedUser = employeeObject.updatedUser;
    employeeDetailsDTO.versionFlag = employeeObject.versionFlag;
    employeeDetailsDTO.employeeType = employeeObject.employeeType;
    employeeDetailsDTO.emailID = employeeObject.emailID;
    employeeDetailsDTO.prefix = employeeObject.prefix;
    employeeDetailsDTO.employeeLastName = employeeObject.employeeLastName;
    //  employeeDetailsDTO.adhaarCard = employeeObject.adhaarCard;
    employeeDetailsDTO.gender = employeeObject.gender;
    employeeDetailsDTO.currentAddress = employeeObject.currentAddress;
    employeeDetailsDTO.permanentAddress = employeeObject.permanentAddress;
    employeeDetailsDTO.maritualStatus = employeeObject.maritualStatus;
    employeeDetailsDTO.nationality = employeeObject.nationality;
    employeeDetailsDTO.bloodGroup = employeeObject.bloodGroup;
    employeeDetailsDTO.employeeStatus = employeeObject.employeeStatus;
    employeeDetailsDTO.contractorName = employeeObject.contractorName;
    employeeDetailsDTO.shiftGroup = employeeObject.shiftGroup;
    employeeDetailsDTO.yearsOfExperience = employeeObject.yearsOfExperience;
    employeeDetailsDTO.companyEmail = employeeObject.companyEmail;
    employeeDetailsDTO.employeeMode = employeeObject.employeeMode;
    employeeDetailsDTO.departmentId = employeeObject.departmentId;
    // employeeDetailsDTO.deptId = employeeObject.deptId;
    employeeDetailsDTO.priorityOne = employeeObject.priorityOne;
    employeeDetailsDTO.priorityType = employeeObject.priorityType;
    employeeDetailsDTO.workstationNumber = employeeObject.workstationNumber;
    employeeDetailsDTO.bankAccountNumber = employeeObject.bankAccountNumber;
    employeeDetailsDTO.bankName = employeeObject.bankName;
    employeeDetailsDTO.ifscCode = employeeObject.ifscCode;
    employeeDetailsDTO.healthCardNumber = employeeObject.healthCardNumber;
    employeeDetailsDTO.uanNumber = employeeObject.uanNumber;
    employeeDetailsDTO.esiNumber = employeeObject.esiNumber;
    employeeDetailsDTO.panNumber = employeeObject.panNumber;
    employeeDetailsDTO.emergencyContactNo = employeeObject.emergencyContactNo;
    employeeDetailsDTO.isProbPeriodCompleted = employeeObject.isProbPeriodCompleted;
    employeeDetailsDTO.transportation = employeeObject.transportation;
    employeeDetailsDTO.accommodation = employeeObject.accommodation;
    employeeDetailsDTO.isAuditCompleted = employeeObject.isAuditCompleted;
    employeeDetailsDTO.skillSet = employeeObject.skillSet;
    employeeDetailsDTO.pickUpPoint = employeeObject.pickUpPoint;
    employeeDetailsDTO.routeNumber = employeeObject.routeNumber;
    employeeDetailsDTO.employeeCategory = employeeObject.employeeCategory;
    employeeDetailsDTO.wageType = employeeObject.wageType;
    employeeDetailsDTO.image = employeeObject.image;
    employeeDetailsDTO.aadhaarNumber = employeeObject.aadhaarNumber;
    employeeDetailsDTO.reportingManager = employeeObject.reportingManager
    employeeDetailsDTO.state = employeeObject.state;
    employeeDetailsDTO.pinCode = employeeObject.pinCode;
    employeeDetailsDTO.permanentState = employeeObject.permanentState;
    employeeDetailsDTO.permanentPinCode = employeeObject.permanentPinCode;
    employeeDetailsDTO.ghiNo = employeeObject.ghiNo;
    employeeDetailsDTO.gpaNo = employeeObject.gpaNo;

    if (employeeObject.familyDetails) {
      const familyData: EmployeeFamilyDetailsDTO[] = []
      for (const iteratoDtoFam of employeeObject.familyDetails) {
        const familyDetailsObj = new EmployeeFamilyDetails();
        if (isUpdate) {
          familyDetailsObj.employeeFamilyId = iteratoDtoFam.employeeFamilyId;
        }
        familyDetailsObj.employeeFamilyId = iteratoDtoFam.employeeFamilyId;
        familyDetailsObj.familyMemName = iteratoDtoFam.familyMemName;
        familyDetailsObj.relation = iteratoDtoFam.relation;
        familyDetailsObj.famAadhaarNo = iteratoDtoFam.famAadhaarNo;
        familyDetailsObj.contactNo = iteratoDtoFam.contactNo;
        familyDetailsObj.famDateOfBirth = iteratoDtoFam.famDateOfBirth;
        familyDetailsObj.isActive = iteratoDtoFam.isActive;
        familyData.push(familyDetailsObj)
      }
      employeeDetailsDTO.familyDetails = familyData
      if (isUpdate) {
        employeeDetailsDTO.updatedUser = employeeDetailsDTO.updatedUser;
      } else {
        employeeDetailsDTO.isActive = true;
      }

    }
    if (employeeObject.educationDetails) {
      const educationDetails: EmployeeEducationDetails[] = [];
      for (const iteratoDtoEdu of employeeObject.educationDetails) {
        const educationDetailsObj = new EmployeeEducationDetails();
        if (isUpdate) {
          educationDetailsObj.employeeEducationId = iteratoDtoEdu.employeeEducationId;
        }
        educationDetailsObj.empQualification = iteratoDtoEdu.empQualification;
        educationDetailsObj.specialization = iteratoDtoEdu.specialization;
        educationDetailsObj.dateOfPassOut = iteratoDtoEdu.dateOfPassOut;
        educationDetailsObj.percentage = iteratoDtoEdu.percentage;
        educationDetailsObj.isActive = iteratoDtoEdu.isActive;
        educationDetails.push(educationDetailsObj)
      }
      employeeDetailsDTO.educationDetails = educationDetails
      if (isUpdate) {
        employeeDetailsDTO.updatedUser = employeeDetailsDTO.updatedUser;
      } else {
        employeeDetailsDTO.isActive = true;
      }
    }
    if (employeeObject.experienceDetails) {
      const experienceDetails: EmployeeExperienceDetails[] = [];
      for (const iteratoDtoExp of employeeObject.experienceDetails) {
        const experienceDetailobj = new EmployeeExperienceDetails();
        if (isUpdate) {
          experienceDetailobj.employeeExperienceId = iteratoDtoExp.employeeExperienceId;
        }
        experienceDetailobj.organisation = iteratoDtoExp.organisation;
        experienceDetailobj.designation = iteratoDtoExp.designation;
        experienceDetailobj.fromDate = iteratoDtoExp.fromDate;
        experienceDetailobj.toDate = iteratoDtoExp.toDate;
        experienceDetailobj.experience = iteratoDtoExp.experience;
        experienceDetailobj.isActive = iteratoDtoExp.isActive;
        experienceDetails.push(experienceDetailobj)
      }
      employeeDetailsDTO.experienceDetails = experienceDetails
      if (isUpdate) {
        employeeDetailsDTO.updatedUser = employeeDetailsDTO.updatedUser;
      } else {
        employeeDetailsDTO.isActive = true;
        // employeeDetailsDTO.isTerminated = No;
      }
    }
    if (employeeObject.idProofDetails) {
      const idProofDetails: EmployeeIdProofDetails[] = [];
      for (const iteratoDtoIdProof of employeeObject.idProofDetails) {
        const idProofdetailsObj = new EmployeeIdProofDetails();
        if (isUpdate) {
          idProofdetailsObj.employeeIdProofId = iteratoDtoIdProof.employeeIdProofId;
        }
        idProofdetailsObj.idNumber = iteratoDtoIdProof.idNumber;
        idProofdetailsObj.idType = iteratoDtoIdProof.idType;
        idProofdetailsObj.isActive = iteratoDtoIdProof.isActive;
        idProofDetails.push(idProofdetailsObj)
      }
      employeeDetailsDTO.idProofDetails = idProofDetails
      if (isUpdate) {
        employeeDetailsDTO.updatedUser = employeeDetailsDTO.updatedUser;
      } else {
        employeeDetailsDTO.isActive = true;
      }
    }


    return employeeDetailsDTO;
  }

}